@if (applicationResource) {
  <div>
    <mat-card>
      <mat-card-header class="table-header">
        <mat-card-title>Detalle de la aplicación</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-application-outline
          [applicationResource]="applicationResource"></app-application-outline>
        <div class="info">
          @if (applicationResource.status) {
            <div class="infoItem"><b>Estado</b>:
              {{ statusEnumLookup[applicationResource.status] }}
            </div>
          }
        </div>
        <div class="actions">
          @if (applicationResource.status === "ISSUING_ERROR") {
            <button mat-raised-button color="primary" (click)="retryAction('issue')">Reintentar
              Emisión
            </button>
          }
          @if (applicationResource.status === "PRINTING_ERROR") {
            <button mat-raised-button color="primary" (click)="retryAction('print')">Reintentar
              Impresión
            </button>
          }
          @if (applicationResource.status === "VALIDATION_ERROR" || applicationResource.status
          === "IN_VALIDATION_MANUAL") {
            <button mat-raised-button color="primary" (click)="retryAction('validate')">Reintentar
              Inspección
            </button>
          }
        </div>
        <br>
        <div class="history">
          <h2>Historial</h2>
          <app-application-messages></app-application-messages>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
}
